import { Spin, Row } from 'antd'
import React from "react";

interface ILoading {
  tip?: string
}

const defaultTip = 'Loading...'

const Loading: React.FC<ILoading> = ({ tip }) => (
  <Row align="middle" justify="center" className="text-center">
    <div
      style={{
        maxWidth: '400px',
        zIndex: 2,
        minWidth: '300px',
      }}
    >
      <Spin tip={tip || defaultTip} spinning={true}></Spin>
    </div>
  </Row>
)

export default Loading
